export enum OrderStatus {
  newOrder = 1,
  receivedByDispatcher = 2,
  treatedByDispatcher = 4,
  acceptedByDriver = 8,
  finished = 16,
  cancelled = 32,
  modified = 64,
  inProgress = 128,
  refusedByDriver = 256,
  all = newOrder | receivedByDispatcher| treatedByDispatcher | acceptedByDriver | finished | cancelled | modified | inProgress | refusedByDriver
}
